
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/artists",
      function () {
        return require("private-next-pages/explore/artists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/artists"])
      });
    }
  